import { Box, Typography, keyframes, styled } from "@mui/material";

import NumberFormats from "components/NumberFormats";
import Side from "./WithdrawOrDepositHistoryTable/Side";
import { SpaceBetweenBox } from "components/GeneralStyled";
import State from "./WithdrawOrDepositHistoryTable/State";

function MobileWithdrawOrDeposit({ data, onClick, isRowBlink = false, bg }) {
  return (
    <BoxStyle onClick={() => onClick(data)} bg={bg} isRowBlink={isRowBlink}>
      <SpaceBetweenBox>
        <Box display="flex" alignItems="center">
          <Typography mr={1} color="text.main" variant="h5">
            {data?.coinName}
          </Typography>

          <Side data={data} />
        </Box>

        <Box display="flex" alignItems="flex-start">
          <Typography
            fontSize={"13px"}
            component="span"
            color="text.main"
          >
            {data.date}
          </Typography>&nbsp;&nbsp;&nbsp;
          <Typography
            fontSize={"13px"}
            component="span"
            color="text.main"
          >
            {data.time}
          </Typography>
        </Box>
      </SpaceBetweenBox>

      <SpaceBetweenBox marginBottom={0} alignItems="center">
        <Box>
          <Typography component="span" variant="h5" color="text.main">
            <NumberFormats value={data?.amount} />
          </Typography>{" "}
          <Typography
            component="span"
            variant="subtitle1"
            color="text.secondary"
          >
            {data?.coinName}
          </Typography>
        </Box>

        <Box>
          <State data={data} />
        </Box>
      </SpaceBetweenBox>
    </BoxStyle>
  );
}


const blink = (color, bg) => keyframes`
  0% {
    background: ${bg};
  }
  50% {
    background: ${color};
  }
  100% {
    background: ${bg};
  }
`;

const BoxStyle = styled(Box, {
  shouldForwardProp: (props) => !['bg', 'isRowBlink'].includes(props)
})(({ theme, bg, isRowBlink }) => ({
  background: bg || theme.palette.background.primaryGradient,
  borderRadius: "8px",
  padding: theme.spacing(1),
  marginBottom: theme.spacing(1),
  animation: (bg && isRowBlink) ? `${blink(bg, theme.palette.background.primaryGradient)} 0.8s ease-in 5 forwards` : "none",
}));

export default MobileWithdrawOrDeposit;
